import styled from '@emotion/styled';

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  margin-top: var(--spacing-4);
`;

export const StyledInput = styled.input`
  transform: scale(1.2);
  accent-color: var(--color-primary-50);
`;

export const Text = styled.label`
  font: var(--font-body-s-light);
  color: var(--color-secondary-60);

  button {
    color: inherit;
    font: inherit;
    padding-inline: var(--spacing-4);
  }
`;
